/* eslint-disable no-unused-vars,react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-duotone-svg-icons';

// actions + utils
import { loadShoppers } from '../../../../actions/shopper';
import { cap } from '../../../../common/utils/prettify';

// components
import LeadsTable from './LeadsTable';
import LeadsFilters from './LeadsFilters';
import EnrollmentTable from './enrollments';
import SOATable from './soas';

function SubTableHeader() {
  const dispatch = useDispatch();
  const {
    selectedShopper = {},
    view,
  } = useSelector(store => store.shoppers);

  function handleClick() {
    const payload = {
      selectedShopper: {},
      view: 'shoppers',
    };
    dispatch({ type: 'SET_SHOPPERS_KEYS', payload });
  }

  return (
    <div className="row">
      <div className="col">
        <button
          type="button"
          className="btn btn-link"
          onClick={() => handleClick()}
        >
          <FontAwesomeIcon icon={faArrowLeft} className="me-3" />
          Back to shopper list
        </button>
      </div>

      <div className="d-flex col justify-content-center align-items-end">
        <h2 className="mb-0">{cap(view)}</h2>
      </div>

      <div className="d-flex col justify-content-end align-items-center">
        <h4 className="mb-0 text-muted">
          {`${selectedShopper.first_name} ${selectedShopper.last_name}`}
          <span className="mx-2">|</span>
          {selectedShopper.lead_id}
        </h4>
      </div>
    </div>
  );
}

function LeadsPage() {
  const dispatch = useDispatch();
  const {
    page: storePage,
    sortTerm: storeSortTerm,
    searchTerm: storeSearchTerm,
    sortDirection: storeSortDirection,
    view = 'shoppers',
  } = useSelector(store => store.shoppers);
  const {
    selectedAgent: {
      username: agentUsername,
    } = {},
  } = useSelector(store => store.agents);
  const { username: profileUsername } = useSelector(store => store.user);
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    dispatch({ type: 'SET_SHOPPER_KEYS', payload: { view: 'shoppers' } });
  }, []);

  function castDirectionToBool(direction) {
    if (direction === 'desc' || direction === true) return true;
    if (direction === 'asc' || direction === false) return false;
    return undefined;
  }

  function handleLoadShoppers({
    page = storePage,
    sortTerm = storeSortTerm,
    searchTerm = storeSearchTerm,
    sortDirection = storeSortDirection,
  } = {}) {
    setLoading(true);
    return loadShoppers({
      agentUsername: (agentUsername || profileUsername),
      page,
      sortTerm,
      searchTerm,
      desc: castDirectionToBool(sortDirection),
    })
      .then((data) => dispatch({ type: 'SET_SHOPPERS_KEYS', payload: data }))
      .catch((err) => {
        console.log(err);
        dispatch({ type: 'CLEAR_SHOPPERS' });
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    handleLoadShoppers();
  }, []);

  return (
    <div className="border row py-4 bg-white">

      {(view === 'shoppers') && (
        <LeadsFilters
          loading={loading}
          handleLoadShoppers={handleLoadShoppers}
        />
      )}
      {((view === 'soas') || (view === 'enrollments')) && (
        <SubTableHeader />
      )}

      <hr className="mt-4" />

      {(view === 'shoppers') && (
        <LeadsTable
          loading={loading}
          handleLoadShoppers={handleLoadShoppers}
        />
      )}
      {(view === 'soas') && <SOATable />}
      {(view === 'enrollments') && <EnrollmentTable />}
    </div>
  );
}

export default LeadsPage;
